import { ResponsiveUtils } from "@sazka/utils/responsive-utils";
import { useSessionStorage } from "@sazka/utils/use-storage";
import { useStickersState } from "@/shared/composables/use-stickers-state";
import { watch } from "vue";
import { useChat } from "./use-chat";

export const useFixedHelp = () => {
    const elem = document.getElementById("fixed-help");
    if (!elem) return;

    const { isFixedHelpCollapsed } = useStickersState();

    bindClickToStartChat();
    fixedHelpCobrowsingModeCheck();
    const isNativeRegistration = !!window.registrationConfiguration;
    const isFixedHelpHiddenByDefault = isNativeRegistration && ResponsiveUtils.breakpointDown("sm2");

    const switchElem = document.getElementById("switch-help");
    switchElem.addEventListener("click", () => {
        isFixedHelpCollapsed.value = !isFixedHelpCollapsed.value;
    });
    const animation = isNativeRegistration ? useFixedHelpAnimation(elem, switchElem, isFixedHelpHiddenByDefault) : null;

    watch(isFixedHelpCollapsed, (newIsFixedHelpCollapsed) => {
        if (!newIsFixedHelpCollapsed) {
            elem.classList.add("active");
            animation?.start();
        } else {
            elem.classList.remove("active");
            animation?.stop(true);
        }
    });

    if (!isFixedHelpCollapsed.value && !isFixedHelpHiddenByDefault) {
        elem.classList.add("active");
    }

    if (isNativeRegistration) {
        animation.start();
    }
};

export function fixedHelpCobrowsingMode() {
    document.getElementById("fixed-help")?.classList?.add("fixed-help--cobrowsing");
    useSessionStorage().setItem("fixed-help--cobromode", "true", "essential");
}

function fixedHelpCobrowsingModeCheck() {
    if (useSessionStorage().getItem("fixed-help--cobromode") === "true") {
        fixedHelpCobrowsingMode();
    }
}

function useFixedHelpAnimation(rootElem: HTMLElement, switchElem: HTMLElement, isFixedHelpHiddenByDefault: boolean) {
    const registrationSettings = window.registrationConfiguration?.settings;
    const ANIMATION_DURATION = 2000;
    // Adding class imediately messes with animation, wait a bit before applying active class to chat
    const ACTIVE_CLASS_DELAY = 200;

    const elemAnimate = rootElem.querySelector(".fixed-help__inner");
    let startAnimationTimer = null;
    let stopAnimationTimer = null;
    let animationInterval = null;
    let isAnimating = false;
    let shouldHideOnEnd = false;
    let didChatOpen = false;

    function startFlow() {
        if (registrationSettings?.disableChatAlerts ?? true) return;

        clearTimeout(startAnimationTimer);
        startAnimationTimer = setTimeout(() => {
            if (isFixedHelpHiddenByDefault) {
                rootElem.classList.add("active");
                shouldHideOnEnd = true;
                isAnimating = true;
                animationInterval = setInterval(() => {
                    if (elemAnimate.classList.contains("is-animating-in")) {
                        elemAnimate.classList.remove("is-animating-in");
                        elemAnimate.classList.add("is-animating-out");
                        switchElem.classList.remove("is-animating-in");
                        switchElem.classList.add("is-animating-out");
                        setTimeout(() => {
                            if (
                                elemAnimate.classList.contains("is-animating-out") &&
                                !rootElem.classList.contains("active")
                            ) {
                                rootElem.classList.add("active");
                            }
                        }, ACTIVE_CLASS_DELAY);
                    } else {
                        elemAnimate.classList.add("is-animating-in");
                        elemAnimate.classList.remove("is-animating-out");
                        switchElem.classList.add("is-animating-in");
                        switchElem.classList.remove("is-animating-out");
                    }
                }, ANIMATION_DURATION);

                stopAnimationTimer = setTimeout(() => {
                    stopAnimation();
                }, registrationSettings?.stopChatAlertAfterSeconds * 1000);
            } else if (!didChatOpen) {
                didChatOpen = true;
                !rootElem.classList.contains("active") && rootElem.classList.add("active");
                useChat().show(true, "DEHRegTimeout", "none");
            }
        }, registrationSettings?.startChatAlertAfterSeconds * 1000);
    }

    function stopAnimation(forceHide = false) {
        clearInterval(animationInterval);
        clearTimeout(stopAnimationTimer);

        if (forceHide) shouldHideOnEnd = false;
        if (shouldHideOnEnd) rootElem.classList.remove("active");

        if (isAnimating) {
            isAnimating = false;
            elemAnimate.classList.remove("is-animating-in");
            elemAnimate.classList.add("is-animating-out");
            switchElem.classList.remove("is-animating-in");
            switchElem.classList.add("is-animating-out");
        }
    }

    function restartFlow() {
        stopAnimation();
        startFlow();
    }

    document.addEventListener("click", (e) => {
        if (!(e.target as HTMLElement).closest("#fixed-help")) {
            restartFlow();
        }
    });

    document.addEventListener("keydown", () => restartFlow());

    return {
        start: startFlow,
        stop: stopAnimation,
    };
}
function bindClickToStartChat() {
    const btns = document.querySelectorAll<HTMLButtonElement>("[data-start=chat]");
    btns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            const campaingCode = (e.currentTarget as HTMLButtonElement).dataset.campaing;
            useChat().show(false, campaingCode);
        });
    });
}
